import React, { Component } from 'react';
import { object } from 'prop-types';
import { observer } from 'mobx-react';
import modalAPI from '../../../api/modal';
import EmbeddedIntegrationContentView from './view';

class EmbeddedIntegrationContent extends Component {
  static propTypes = {
    api: object.isRequired,
    integrationConfig: object.isRequired,
  };

  state = {
    input: {
      trackingId: '',
      isDirty: false,
      isValid: false,
    },
  };

  componentDidMount() {
    const { integrationConfig, api } = this.props;
    api.createDraft(integrationConfig);
    this.setInitialTrackingId();
  }

  setInitialTrackingId = () => {
    const params = modalAPI.getParams();
    const { trackingId } = (params.integrationData &&
      params.integrationData.content) || { trackingId: '' };
    const isValid =
      this.props.integrationConfig.trackingId &&
      this.props.integrationConfig.trackingId.validator(trackingId);
    const { isDirty } = params;

    params.isValid = isValid;
    modalAPI.setParams(params);
    this.setState({
      input: {
        isDirty,
        trackingId,
        isValid,
      },
    });
  };

  handleParamChange(property, value) {
    const params = modalAPI.getParams();
    if (params.integrationData) {
      params.integrationData.content[property] = value;
      params.isDirty = true;
    }
    params.isValid = this.state.input.isValid;
    modalAPI.setParams(params);
  }

  handleToggleCheckbox = ({ target: { checked } }) => {
    this.handleParamChange('ipAnonymization', checked);
  };

  handleInputChange = ({ target: { value } }) => {
    const isValid = this.props.integrationConfig.trackingId.validator(value);
    this.setState(
      {
        input: {
          trackingId: value,
          isValid,
          isDirty: true,
        },
      },
      () => this.handleParamChange('trackingId', value),
    );
  };

  render() {
    const { trackingId, isValid } = this.state.input;

    const {
      isDirty = false,
      integrationData: { content: { ipAnonymization: isChecked } = {} } = {},
    } = modalAPI.getParams();

    const {
      integrationConfig: { type, checkbox, trackingId: { placeholder } = {} },
    } = this.props;

    return (
      <EmbeddedIntegrationContentView
        trackingId={trackingId}
        isValid={isValid}
        isDirty={isDirty}
        isChecked={isChecked}
        type={type}
        checkbox={checkbox}
        placeholder={placeholder}
        onInputChange={this.handleInputChange}
        onToggleCheckbox={this.handleToggleCheckbox}
      />
    );
  }
}

export default observer(EmbeddedIntegrationContent);
